import React from 'react'

const FilterCount = ({ results }) => {
  return (
    <div className="filter-count">
      <p>{results} {results !== 1 ? 'results' : 'result'}</p>
    </div>
  )
}

export default FilterCount
